import * as colors from 'shared/styles/colors';

export const defaultTheme = {
  sensorAlarmFilterBackground: colors.backgroundWhite,
  sensorAlarmFilterActive: colors.lightBlue20,
};
